// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13WJO","rootMobile":"styles_rootMobile__2eGmY"};